import React from 'react';
import { Link } from 'react-router-dom';

// Imágenes
import ImgEquipoEyector from '../img/products/otrosEquipos/EquipoEyector/EquipoEyector1.png';
import ImgEquipoLlenadotanque from '../img/products/otrosEquipos/EquipoLlenadoTanque/LenadoTanque1.png';
import ImgEquipoOilGas from '../img/products/otrosEquipos/EquipoOilGas/OilGas1.png';
import ImgEquipoRiegoDrenaje from '../img/products/otrosEquipos/EquipoRiegoDrenaje/RiegoDrenaje1.png';

const equipos = [
    { nombre: 'Equipo de Eyector', ruta: '/EquipoEyector', img: ImgEquipoEyector },
    { nombre: 'Equipo de Llenado de Tanque', ruta: '/EquipoLlenadoTanque', img: ImgEquipoLlenadotanque },
    { nombre: 'Equipo de Oil & Gas', ruta: '/EquipoOilGas', img: ImgEquipoOilGas },
    { nombre: 'Equipo de Riego y Drenaje', ruta: '/EquipoRiegoDrenaje', img: ImgEquipoRiegoDrenaje },
];

const OtrosEquipos = () => {
    return (
        <div className="container my-5">
            <h3 className="mb-4 text-center">Otros Equipos de Bombeo</h3>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 g-4">
                {equipos.map((equipo, index) => (
                    <div className="col" key={index}>
                        <div className="card h-100 shadow-sm">
                            <Link to={equipo.ruta} className="text-decoration-none text-dark">
                                <img 
                                    src={equipo.img} 
                                    className="card-img-top" 
                                    alt={equipo.nombre} 
                                    style={{
                                        height: '200px',
                                        objectFit: 'cover',
                                        width: '100%',
                                    }}
                                />
                                <div className="card-body text-center">
                                    <h5 className="card-title">{equipo.nombre}</h5>
                                </div>
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OtrosEquipos;
